<template>
  <v-row class="news-widget">
    <div class="widget-content">
      <v-layout row class="news" @click.stop="openDialog">
        <v-flex xs12>
          <div v-if="newsFeedList">
            <div v-for="(item, index) in newsFeedList" :key="index + 1">
              <div v-if="currentCounter === index" class="card">
                <div class="title font-regular text-center">
                  {{ item.headline }}
                </div>
                <div class="font-italic caption text-center source">
                  {{ currentSource }}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p>{{ $t('widgets.news.loadingNews') }}</p>
          </div>
        </v-flex>
      </v-layout>
      <div class="remove-btn news">
        <remove-button :widget-position="currentWidget" :widget-name="widgetName" />
      </div>
    </div>
    <v-dialog v-model="dialog" scrollable max-width="500" dark>
      <widgetForm
        :show-form="showForm"
        :widget-schema="formSchema"
        :widget-values="formValues"
        :widget-name="widgetName"
        :widget-position="currentWidget"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import { parseString } from 'xml2js'
import { mixin as VueTimers } from 'vue-timers'
import WidgetForm from '../../components/Forms/widgetForm'
import RemoveButton from '../../components/Buttons/RemoveButton'

const corsAny = 'https://cors-anywhere.herokuapp.com/'

const feedList = {
  bbcWorldFeed: 'http://feeds.bbci.co.uk/news/world/rss.xml',
  nytWorldFeed: 'https://rss.nytimes.com/services/xml/rss/nyt/World.xml',
  buzzFeedFeed: 'https://www.buzzfeed.com/world.xml',
  yahooFeed: 'https://www.yahoo.com/news/rss/world',
  cnnWorldFeed: 'http://rss.cnn.com/rss/edition_world.rss',
  guardianFeed: 'https://www.theguardian.com/world/rss',
  wasningtonPostFeed: 'http://feeds.washingtonpost.com/rss/world',
  cnbcFeed: 'https://www.cnbc.com/id/100727362/device/rss/rss.xml',
  rtFeed: 'https://www.rt.com/rss/news/',
  nprFeed: 'https://feeds.npr.org/1004/rss.xml',
  sputnikFeed: 'https://sputniknews.com/export/rss2/world/index.xml',
  spiegleFeed: 'https://www.spiegel.de/international/index.rss',
  independantFeed: 'http://www.independent.co.uk/news/world/rss',
  abcFeed: 'https://abcnews.go.com/abcnews/internationalheadlines',
  rteNewsFeed: 'https://www.rte.ie/feeds/rss/?index=/news/&limit=10',
  skyNewsFeed: 'http://feeds.skynews.com/feeds/rss/world.xml',
  france24FrFeed: 'https://www.france24.com/fr/rss'
}
export default {
  name: 'News',
  components: {
    WidgetForm,
    RemoveButton
  },
  mixins: [VueTimers],
  props: {
    widgetData: {
      type: Object,
      required: false
    },
    widgetName: {
      type: String,
      required: true
    },
    paidPlan: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      showForm: false,
      currentWidget: this.$attrs.position,
      formValues: {},
      formSchema: {},
      errors: [],
      showHowMany: 3,
      loading: true,
      hasPlan: this.paidPlan,
      newsFeedList: null,
      currentCounter: 0,
      currentSource: null
    }
  },
  timers: {
    changeCounter: {
      time: 15000,
      autostart: true,
      repeat: true,
      imediate: true
    }
  },
  computed: {
    /* Create defaults for this widget */
    useData() {
      return (
        this.widgetData || {
          sourceRadio: 'bbcWorldFeed'
        }
      )
    },
    getCurrentLang() {
      return this.$i18n.locale
    }
  },
  mounted() {
    this.currentFeed = this.widgetData.sourceRadio
    this.getNews()
  },
  // beforeDestroy() {
  //   clearInterval(this.$options.interval)
  // },
  methods: {
    openDialog() {
      this.setFormSchema()
      this.setFormValues()
      this.dialog = true
      this.showForm = true
    },
    setFormSchema() {
      const freeFormSchema = {
        regText: {
          type: 'htmlText',
          value: this.$i18n.t('widgets.news.upgradeMsg'),
          flex: 12
        },
        sourceRadio: {
          type: 'radio',
          label: this.$i18n.t('widgets.news.form.freeMsg'),
          options: [
            {
              label: 'BBC World News',
              value: 'bbcWorldFeed'
            },
            {
              label: 'New York Times',
              value: 'nytWorldFeed'
            },
            {
              label: 'BuzzFeed',
              value: 'buzzFeedFeed'
            },
            {
              label: 'Sky News',
              value: 'skyNewsFeed'
            },
            {
              label: 'CNN World',
              value: 'cnnWorldFeed'
            }
          ],
          flex: 12
        }
      }
      const proFormSchema = {
        sourceRadio: {
          type: 'radio',
          label: this.$i18n.t('widgets.news.form.freeMsg'),
          options: [
            {
              label: 'BBC World News',
              value: 'bbcWorldFeed'
            },
            {
              label: 'New York Times',
              value: 'nytWorldFeed'
            },
            {
              label: 'BuzzFeed',
              value: 'buzzFeedFeed'
            },
            {
              label: 'Sky News',
              value: 'skyNewsFeed'
            },
            {
              label: 'CNN World',
              value: 'cnnWorldFeed'
            }
          ],
          flex: 12
        },
        regPROText: {
          type: 'htmlText',
          value: this.$i18n.t('widgets.news.form.proMsg'),
          flex: 12
        },
        source_ap: {
          type: 'switch',
          label: 'AP (Associated Press)',
          flex: 6
        },
        source_reuters: {
          type: 'switch',
          label: 'Reuters',
          flex: 6
        },
        source_bbc: {
          type: 'switch',
          label: 'BBC World News (UK)',
          flex: 6
        },
        source_nyt: {
          type: 'switch',
          label: 'New York Times (US)',
          flex: 6
        },
        source_npr: {
          type: 'switch',
          label: 'NPR (US)',
          flex: 6
        },
        source_wp: {
          type: 'switch',
          label: 'Washington Post',
          flex: 6
        },
        source_al: {
          type: 'switch',
          label: 'Al Jazeera',
          flex: 6
        }
      }
      this.formSchema = this.paidPlan ? proFormSchema : freeFormSchema
    },
    setFormValues() {
      this.formValues.sourceRadio = this.useData.sourceRadio || 'bbcWorldFeed'
      this.formValues.source_ap = this.useData.source_ap || false
      this.formValues.source_reuters = this.useData.source_reuters || false
      this.formValues.source_bbc = this.useData.source_bbc || false
      this.formValues.source_nyt = this.useData.source_nyt || false
      this.formValues.source_npr = this.useData.source_npr || false
      this.formValues.source_wp = this.useData.source_wp || false
      this.formValues.source_al = this.useData.source_al || false
    },
    removeWidget() {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.currentWidget]: 'blank'
      })
    },
    /* Close the dialog and reset the props so that state aligns */
    closeDialog() {
      this.$timer.stop('changeCounter')
      this.dialog = false
      this.showForm = false
      this.setFormValues()
      this.formSchema = {}
      this.newsFeedList = null
      this.$nextTick(() => {
        this.$timer.start('changeCounter')
      })
    },
    changeCounter() {
      if (this.useData.sourceRadio !== this.currentFeed) {
        this.currentCounter = 0
        this.currentFeed = this.useData.sourceRadio
        this.getNews(this.useData.sourceRadio)
      }
      if (this.currentCounter === 10) {
        this.currentCounter = 0
      } else {
        this.currentCounter = this.currentCounter + 1
      }
      if (this.currentCounter === 0) {
        this.getNews()
      }
    },
    getNews() {
      const newsFeedList = []
      axios.get(corsAny + feedList[this.currentFeed]).then(response => {
        parseString(response.data, (err, result) => {
          if (err) {
            console.log('error is: ', err)
          } else {
            const feedResult = result.rss.channel[0].item
            const currentFeed = feedResult.slice(0, 10)
            // eslint-disable-next-line
            this.currentSource = this.cleanSource(this.currentFeed)
            // eslint-disable-next-line
            currentFeed.forEach(function (resultItem, index) {
              const feedItem = {
                headline: resultItem.title[0],
                // eslint-disable-next-line
                description: resultItem.description[0].replace(/(<([^>]+)>)/ig,"")
              }
              newsFeedList.push(feedItem)
            })
            this.newsFeedList = newsFeedList
            this.newsFeed = feedResult
            this.currentCounter = 0
            // this.$options.interval = setInterval(this.changeCounter, 10000)
          }
        })
      })
    },
    cleanSource(source) {
      switch (source) {
        case 'bbcWorldFeed':
          return 'BBC World News (UK)'
        case 'nytWorldFeed':
          return 'New York Times (USA)'
        case 'buzzFeedFeed':
          return 'BuzzFeed (USA)'
        case 'yahooFeed':
          return 'Yahoo! News (USA)'
        case 'cnnWorldFeed':
          return 'CNN World News (USA)'
        case 'guardianFeed':
          return 'Guardian (UK)'
        case 'wasningtonPostFeed':
          return 'The Washington Post (US)'
        case 'cnbcFeed':
          return 'CNBC (US)'
        case 'rtFeed':
          return 'Russia Today (RU)'
        case 'nprFeed':
          return 'NPR (USA)'
        case 'sputnikFeed':
          return 'Sputnik (RU)'
        case 'spiegleFeed':
          return 'Der Spiegle (DE)'
        case 'independantFeed':
          return 'The Independent (UK)'
        case 'abcFeed':
          return 'ABC (USA)'
        case 'rteNewsFeed':
          return 'RTE (IE)'
        case 'skyNewsFeed':
          return 'Sky News (UK)'
        case 'france24FrFeed':
          return 'France24 (FR)'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news-widget {
  margin: 0 20px;
  .remove-btn {
    text-align: center;
    font-size: 12px;
    transition: 0s;
    opacity: 0;
    &.clock {
      position: relative;
      top: -20px;
    }
  }
  &:hover {
    cursor: pointer;
    .remove-btn {
      opacity: 0.8;
      transition-delay: 1.5s;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    }
  }
  .news {
    .card {
      .title {
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
      }
      .source {
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 1s ease;
}

.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>
